import { GB_FEATURE_KEYS } from '~/services/abTests/features';
import { growthBook } from '~/services/abTests/growthBook';

import { COMPLIANCE_PROFILES, ComplianceProfile } from './profiles';
import { resolveComplianceLevel } from './resolveComplianceLevel';

/**
 * Synchronous compliance profile, read straight off the GrowthBook singleton.
 * For non-React call sites (e.g. SideBarItemType.checkAvailability). React
 * components should use useComplianceProfile so they re-render on flag load.
 */
export const getComplianceProfile = (): ComplianceProfile => {
  const level = resolveComplianceLevel({
    v1: Boolean(
      growthBook.getFeatureValue(GB_FEATURE_KEYS.POLYLLM_COMPLIANCE_V1),
    ),
    v2: Boolean(
      growthBook.getFeatureValue(GB_FEATURE_KEYS.POLYLLM_COMPLIANCE_V2),
    ),
  });
  return COMPLIANCE_PROFILES[level];
};
